let id: string;

function init(newId: string) {
    id = newId;
}

function intercom(...a: any[]) {
    window.Intercom && window.Intercom(...a);
}

function boot(userData = {}) {
    if (!id) throw new Error('Intercom: no id provided');

    intercom('boot', {
        app_id: id,
        user_data: userData
    });
}

function setUser(user: anm.User) {
    const { username, email, userId, avatar } = user;

    if (username && email && userId && avatar) {
        boot({
            email,
            avatar,
            user_id: userId,
            name: username
        });
    }
}

function setAnonymous() {
    intercom('shutdown');
    boot();
}

function show() {
    intercom('show');
}

function hide() {
    intercom('hide');
}

function unreadCountChange(cb: (n: number) => void) {
    intercom('onUnreadCountChange', cb);
}

export default {
    init,
    boot,
    setUser,
    setAnonymous,
    show,
    hide,
    unreadCountChange
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/intercom.ts